// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 2H2V22H12.5057C11.5642 20.8397 11 19.3607 11 17.75C11 15.7807 11.8434 14.0083 13.1886 12.7744L9 8.58579L4 13.5858V4H20V11.3841C20.7331 11.6432 21.408 12.0253 22 12.5057V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M16 5.25C14.4812 5.25 13.25 6.48122 13.25 8C13.25 9.51878 14.4812 10.75 16 10.75C17.5188 10.75 18.75 9.51878 18.75 8C18.75 6.48122 17.5188 5.25 16 5.25Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M17.6538 12.5C14.8075 12.5 12.5 14.8075 12.5 17.6538C12.5 20.5002 14.8075 22.8077 17.6538 22.8077C18.7156 22.8077 19.7032 22.4859 20.5232 21.9356L22.499 23.9142L23.9142 22.501L21.937 20.521C22.4865 19.7014 22.8077 18.7146 22.8077 17.6538C22.8077 14.8075 20.5002 12.5 17.6538 12.5ZM14.5 17.6538C14.5 15.912 15.912 14.5 17.6538 14.5C19.3957 14.5 20.8077 15.912 20.8077 17.6538C20.8077 18.5245 20.4562 19.3112 19.885 19.8829C19.3131 20.4554 18.5256 20.8077 17.6538 20.8077C15.912 20.8077 14.5 19.3957 14.5 17.6538Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-image-search-filled')
export default class ImageSearchFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'image-search-filled',
    }
  }
}
